import { Observable, } from 'zen-observable-ts';
import 'symbol-observable';
var prototype = Observable.prototype;
var fakeObsSymbol = '@@observable';
if (!prototype[fakeObsSymbol]) {
    prototype[fakeObsSymbol] = function () { return this; };
}
export { Observable };
//# sourceMappingURL=Observable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/utilities/observables/Observable.js
// module id = 408
// module chunks = 4